import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { GuestList } from 'reservations/guests/components/GuestList';

export const ViewGuestsModal = () => (
  <BaseDrawer header="View guests">
    <GuestList allowRemoval={false} includeDividers={false} />
  </BaseDrawer>
);
